export { Img } from './Img';
import { ImgProps as _ImgProps } from './Img';
export type ImgProps = _ImgProps;
